import React from "react"
import {BankLogoProps, defaultBankLogoSize} from "./bankLogoUtils"

export function BlueRidgeBankLogo({size = defaultBankLogoSize, fill, className}: BankLogoProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 28 28"
			className={className}
		>
			<path fill={fill} d="M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14Z" />
			<g clipPath="url(#a)">
				<path fill="#292D7F" d="M9.865 15.091v-6.9h5.106V6H7.75V17.282h7.713v-2.19H9.866Z" />
				<path fill="#5DBB46" d="M12.037 10.718v2.19h5.598v6.901h-5.106v2.19h7.221V10.719h-7.713Z" />
			</g>
			<defs>
				<clipPath id="a">
					<path fill="#fff" d="M7.75 6h12v16h-12z" />
				</clipPath>
			</defs>
		</svg>
	)
}
